import i18n from "i18n";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Collections } from "@graylog/enterprise-api";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
export const SHARED_COLLECTIONS_QUERY_KEY = "shared_collections";
export const keyFn = (searchParams, filterBy, id) => [
  SHARED_COLLECTIONS_QUERY_KEY,
  filterBy,
  id,
  searchParams
];
export const fetchPaginatedSharedCollections = async (searchParams, filterBy, id) => Collections.getSharedPaginated(
  id,
  filterBy,
  searchParams.sort.attributeId,
  searchParams.page,
  searchParams.pageSize,
  searchParams.query,
  FiltersForQueryParams(searchParams.filters),
  searchParams.sort.direction
).then(({ elements, query, attributes, pagination: { count, total, page, per_page: perPage } }) => ({
  list: elements,
  attributes,
  pagination: {
    count,
    total,
    page,
    perPage,
    query
  }
}));
const useSharedCollections = (searchParams, id, filterBy, { enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: keyFn(searchParams, filterBy, id),
    queryFn: () => defaultOnError(
      fetchPaginatedSharedCollections(searchParams, filterBy, id),
      i18n.t("notifications.fetch_collections_failed", { ns: "enterprise_collections" }),
      i18n.t("notifications.fetch_collections_failed_title", { ns: "enterprise_collections" })
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading,
    refetch
  };
};
export default useSharedCollections;
